module.exports = __webpack_public_path__ + "static/media/Fantom Sonata.2807ab2e.png";